import { Link } from "react-router-dom";
import { Phone, Mail, Instagram, Facebook, MapPin } from "lucide-react";
import { CONTACT } from "@/lib/services";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="timber-grain text-[#FDFBF7] mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid gap-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4 mb-6">
            <img
              src="https://customer-assets.emergentagent.com/job_green-joinery/artifacts/7zg5z0zf_21E4688E-75F7-4055-B92D-0D3F251D117A.png"
              alt="Woodland Joinery and Building"
              className="h-20 w-20 object-contain"
            />
            <div>
              <div className="font-display text-2xl">Woodland</div>
              <div className="text-[10px] tracking-[0.35em] uppercase text-[#C8A24B]">
                Joinery &amp; Building
              </div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-white/50 mt-1">
                Built Around You
              </div>
            </div>
          </div>
          <p className="text-[15px] leading-relaxed text-white/70 max-w-md">
            Bespoke joinery, extensions and full building work — crafted in
            Sheffield, delivered across South Yorkshire and Derbyshire.
          </p>

          <div className="flex items-center gap-4 mt-8">
            <a
              href={CONTACT.socials.instagram}
              data-testid="footer-instagram"
              aria-label="Instagram"
              className="h-10 w-10 border border-white/20 flex items-center justify-center hover:border-[#C8A24B] hover:text-[#C8A24B] transition"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a
              href={CONTACT.socials.facebook}
              data-testid="footer-facebook"
              aria-label="Facebook"
              className="h-10 w-10 border border-white/20 flex items-center justify-center hover:border-[#C8A24B] hover:text-[#C8A24B] transition"
            >
              <Facebook className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-[11px] tracking-[0.3em] uppercase text-[#C8A24B] mb-6">
            Navigate
          </h4>
          <ul className="space-y-3 text-white/80">
            {["Home", "Services", "Gallery", "About", "Contact"].map((l) => (
              <li key={l}>
                <Link
                  to={l === "Home" ? "/" : `/${l.toLowerCase()}`}
                  data-testid={`footer-link-${l.toLowerCase()}`}
                  className="link-underline"
                >
                  {l}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-[11px] tracking-[0.3em] uppercase text-[#C8A24B] mb-6">
            Get in touch
          </h4>
          <ul className="space-y-4 text-white/85">
            <li className="flex items-start gap-3">
              <Phone className="h-4 w-4 text-[#C8A24B] mt-1 shrink-0" />
              <div>
                <div className="text-xs uppercase tracking-widest text-white/50">
                  {CONTACT.sean.name}
                </div>
                <a
                  href={CONTACT.sean.tel}
                  data-testid="footer-phone-sean"
                  className="link-underline"
                >
                  {CONTACT.sean.phone}
                </a>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="h-4 w-4 text-[#C8A24B] mt-1 shrink-0" />
              <div>
                <div className="text-xs uppercase tracking-widest text-white/50">
                  {CONTACT.rocky.name}
                </div>
                <a
                  href={CONTACT.rocky.tel}
                  data-testid="footer-phone-rocky"
                  className="link-underline"
                >
                  {CONTACT.rocky.phone}
                </a>
              </div>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 text-[#C8A24B]" />
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="footer-email"
                className="link-underline"
              >
                {CONTACT.email}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="h-4 w-4 text-[#C8A24B]" />
              <span>{CONTACT.area}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <span>© {new Date().getFullYear()} Woodland Joinery &amp; Building. All rights reserved.</span>
          <span>Crafted in Sheffield.</span>
        </div>
      </div>
    </footer>
  );
}
